<template>
    <div class="mcc-row">
        <div class="mcc-col">
            <mfc-icon-search :key="currentIconSet" :icon-set="currentIconSet" class="mfc-icon-search-input" :value="currentIcon" :disabled="disabled" id="processLogoSelect" label="Process logo"  @change="handleDropdownChange($event)"></mfc-icon-search>
            <div class="mfc-checkbox-wrapper mfc-form-input-container   mu-mt-03" v-if="!disabled">
                <input type="checkbox" id="coloricon" class="mfc-switch" name="toggleIcon"
                    :checked="currentIconSet == 'office' || currentIconSet === 'fluency-color'" @change="setIconSet($event.target.checked)">
                <label for="coloricon">Coloured icons</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['label', 'disabled', 'iconSet', 'defaultIcon'],
    data() {
        return {
            currentIconSet: this.iconSet,
            selectObj: null,
            currentIcon: this.defaultIcon,
        }
    },
   
    methods: {
        handleDropdownChange(e) {
            this.currentIcon = e.target.value;
            this.$emit('iconUpdate', { icon: e.target.value, iconSet: this.currentIconSet})
        },
        setIconSet(isChecked) {
            this.currentIcon = '';
            this.currentIconSet = isChecked ? 'fluency-color' : '';
            this.$emit('iconUpdate', { icon: this.currentIcon, iconSet: this.currentIconSet})
        }
    },
}
</script>


